export default "__VITE_ASSET__DuLVtfs1__"